<template>
    <DashboardEditSection class="CompanyForm" title="Company">
        <template v-if="computedCompany">
            <FormInput v-model="computedCompany.name" label="Company Name" disabled/>
            <FormSelectTimeZone v-model="computedCompany.timeZone"/>
            <CompanyLogoForm/>
            <Button class="saveBtn primary" @click="handleSave" :disabled="submitPending">Save</Button>
        </template>
        <template v-else>
            <h2>Loading Company...</h2>
        </template>
    </DashboardEditSection>
</template>


<script>
import { mapState } from 'vuex';
import * as api from '@/api';
import DashboardEditSection from '@/components/DashboardEditSection';
import CompanyLogoForm from './CompanyLogoForm';

export default {
    name: 'CompanyForm',

    components: { DashboardEditSection, CompanyLogoForm },

    props: {
        company: { type: Object, default: null },
    },

    computed: {
        ...mapState('auth', ['user']),

        computedCompany: {
            get() {
                return this.company;
            },
            set(value) {
                return this.$emit('update:company', value)
            },
        },
    },

    data: () => ({
        submitPending: false,
        submitError: null,
    }),

    methods: {
        async handleSave() {
            if (this.submitPending) return;

            this.submitPending = true;
            const res = await api.updateCompany(this.computedCompany.id, this.computedCompany);
            this.submitPending = false;

            if (res.error) {
                this.submitError = res.error;
                return this.$awn.alert('Failed to update company');
            }

            this.computedCompany = res.body;
            this.$awn.success('Company has been updated');

            this.$store.dispatch('auth/refreshUser');
        },
    },
};
</script>


<style lang="scss" scoped>
@import 'globals.scss';
.CompanyForm {
    .saveBtn {
        display: block;
        margin-left: auto;
    }
}
</style>
